import { createAction } from 'redux-actions';

export const setSchoolNames = createAction('SET_SCHOOL_NAMES');
export const setLoadingSchoolNames = createAction('SET_LOADING_SCHOOL_NAMES');
export const setCourses = createAction('SET_COURSES');
export const setDayLocations = createAction('SET_DAY_LOCATIONS');
export const setPrices = createAction('SET_PRICES');
export const setPcTypes = createAction('SET_PC_TYPES');
export const setOpenPopover = createAction('SET_OPEN_POPOVER');
export const setIsFreeTrial = createAction('SET_IS_FREE_TRIAL');
export const toggleModal = createAction('TOGGLE_MODAL');
export const setPcSucceed = createAction('SET_PC_SUCCEED');
export const setInnovationStudioSelected = createAction('SET_INNOVATION_STUDIO_SELECTED');
export const setContinued = createAction('SET_CONTINUED');
// saga
export const SAGA_INITIALIZE = 'SAGA_INITIALIZE';
export const SAGA_GET_COURSES = 'SAGA_GET_COURSES';
export const SAGA_GET_DAY_LOCATIONS = 'SAGA_GET_DAY_LOCATIONS';
export const SAGA_GET_PRICES = 'SAGA_GET_PRICES';
export const SAGA_GET_PC_TYPES = 'SAGA_GET_PC_TYPES';
export const SAGA_OPEN_POP_OVER = 'SAGA_OPEN_POP_OVER';
export const SAGA_SET_PC_TYPE = 'SAGA_SET_PC_TYPE';
